import type { TableColumn } from "@/components/widgets/Revision/types";

export const getValueBy = (
	value: keyof TableColumn,
	timeFrame: string,
	ee?: TableColumn[],
) => {
	if (ee !== undefined) {
		for (const table of ee) {
			if (
				table.type === "Q"
					? `${table.type}${table.quarter}/${table.year}` === timeFrame
					: `${table.type}/${table.year}` === timeFrame
			) {
				return table[value];
			}
		}
	}
	return null;
};
